<script>
/**
 * Horizontal Bar Chart creates a stacked bar visualization based on the 
 * predefined configuration definition and the data provided as 'stats' 
 * prop. Reactive to data changes.
 */


import { HorizontalBar, mixins } from 'vue-chartjs';

export default {
    data: () => ({
        xtitle: "",
        ytitle: ""
    }),
    extends: HorizontalBar,
    name: 'HorizontalBarChart',
    mixins: [ mixins.reactiveData ],
    props: {
        stats: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.renderChart(this.stats, this.options());
    },
    updated() {
        this.renderChart(this.stats, this.options());
    },
    methods: {
        options() {
            const colors = this.$vuetify.theme.isDark ? 
                this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;

            if(this.stats.datasets){
                this.xtitle = this.stats.datasets[0].xtitle;
                this.ytitle = this.stats.datasets[0].ytitle;
            }

            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            borderDash: [4, 4],
                            color: this.$vuetify.theme.themes.dark.dddarkblue
                        },
                        ticks: {
                            fontColor: colors.ddwhite,
                            fontSize: 14
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.xtitle
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            borderDash: [4, 4],
                            color: this.$vuetify.theme.themes.dark.dddarkblue
                        },
                        ticks: {
                            fontColor: colors.ddwhite,
                            fontSize: 14
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.ytitle
                        }
                    }]
                },
                legend: { display: false },
                plugins: { datalabels: false }
            };
        }
    },
    watch: {
        stats(newStats) {
            this.renderChart(newStats, this.options());
        }
    }
}
</script>
